// This icon file is generated automatically.
var PForwardOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 10 10", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M9.9 4.78L5.41.9C5.25.76 5 .9 5 1.12v7.76c0 .23.25.36.41.22l4.5-3.88a.3.3 0 000-.44zm-5 0L.41.9C.25.76 0 .9 0 1.12v7.76c0 .23.25.36.41.22l4.5-3.88A.3.3 0 005 5a.3.3 0 00-.1-.22z", "fill-rule": "nonzero" } }] }, "name": "p-forward", "theme": "outlined" };
export default PForwardOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PForwardOutlined.js
// module id = 3426
// module chunks = 0